import { render, staticRenderFns } from "./enduranceText.vue?vue&type=template&id=64a357ba&scoped=true&"
import script from "./enduranceText.vue?vue&type=script&lang=js&"
export * from "./enduranceText.vue?vue&type=script&lang=js&"
import style0 from "./enduranceText.vue?vue&type=style&index=0&id=64a357ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a357ba",
  null
  
)

export default component.exports